import * as React from 'react';
import { graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';

import Layout from '../layout/layout';
import Image from '../components/image';
import MixedHeading from '../components/mixed-heading';
import Emoji from '../util/emoji';
import PageBuilder from '../components/page-builder';
import ProjectCard from '../components/card-project';

const Page = ({ data }) => {
	const page = data.page.nodes[0];
	const related = data.related.nodes;
	const seo = page.seo;
	const loopProjects = related.length > 4 ? true : false;

	let scrim = 16;
	if (page.scrim) {
		scrim = page.scrim;
	}

	let subBrand = 'Media';
	let subStyle = 'media';
	if (page.subbrand === 'wild') {
		subBrand = 'The Wild';
		subStyle = 'wild';
	}
	if (page.subbrand === 'creators') {
		subBrand = 'Creators';
		subStyle = 'jungle';
	}
	return (
		<Layout>
			<HelmetDatoCms seo={seo} />
			<main className={`sb-${subStyle}`}>
				<section
					className={`page-hero project-hero s-lg p-lg bg-black`}
				>
					<div
						className={`scrim bg-black`}
						style={{ opacity: scrim + '%' }}
					/>
					<div className='hero-media'>
						<Image data={page} />
					</div>

					<div className='content'>
						<div className='tags'>
							<div className='tag tag-subbrand'>{subBrand}</div>
							<div className='tag tag-rounded tag-client'>
								{page.client}
							</div>
						</div>

						<MixedHeading data={page.heading} size='h1' />
					</div>

					<div className='categories'>
						{page.categories.map((category) => (
							<div className='category-tag'>{category.title}</div>
						))}
					</div>
				</section>
				{page.results.length > 0 && (
					<section className={`results-list s-md p-md bg-pink`}>
						{page.results.map((result) => (
							<div key={result.id} className='results-item'>
								{result.emoji[0] && (
									<Emoji type={result.emoji[0].emoji} />
								)}
								<h4>{result.text}</h4>
							</div>
						))}
					</section>
				)}
				<PageBuilder data={page.builder} />
				<section className={`work-carousel s-lg bg-black`}>
					<div className='heading p-lg'>
						<h1>More from {subBrand}</h1>
					</div>
					<Swiper
						modules={[Mousewheel]}
						slidesPerView={1}
						centeredSlides={true}
						spaceBetween={24}
						grabCursor={true}
						speed={1200}
						loop={loopProjects}
						mousewheel={{
							forceToAxis: true,
							releaseOnEdges: true,
						}}
						breakpoints={{
							0: {
								slidesPerView: 1, // Change slidesPerView to 2.2 when viewport width is 1080px or less
							},
							780: {
								slidesPerView: 1.2, // Change slidesPerView to 2.2 when viewport width is 1080px or less
							},
							1080: {
								slidesPerView: 1.5, // Change slidesPerView to 2.2 when viewport width is 1080px or less
								spaceBetween: 40,
							},
							1280: {
								slidesPerView: 1.6, // Change slidesPerView to 2.2 when viewport width is 1080px or less
							},
						}}
						className='work-carousel-inner'
					>
						{related.map((project) => (
							<SwiperSlide>
								<ProjectCard data={project} key={project.id} />
							</SwiperSlide>
						))}
					</Swiper>
					{/* <MediaItem data={data.media} classes={data.orientation} animate={true} size={data.size} /> */}
				</section>
			</main>
		</Layout>
	);
};

export default Page;

export const query = graphql`
	query ($id: String!, $subbrand: String!) {
		page: allDatoCmsProject(filter: { id: { eq: $id } }) {
			nodes {
				id
				title
				client
				subbrand
				categories {
					id
					title
				}
				results: keyStats {
					id
					text
					emoji {
						emoji
					}
				}
				loader: image {
					alt
					url(imgixParams: { auto: "compress", w: "32" })
				}
				image {
					alt
					url(imgixParams: { auto: "compress", w: "1920" })
				}
				scrim
				heading {
					... on DatoCmsEmoji {
						...EmojiContent
					}
					... on DatoCmsUniversal {
						...UniversalContent
					}
					... on DatoCmsFeature {
						...FeatureContent
					}
				}
				builder {
					__typename
					... on DatoCmsText {
						...TextBlock
					}
					... on DatoCmsCalloutText {
						...CalloutText
					}
					... on DatoCmsSingle {
						...Single
					}
					... on DatoCmsImageGrid {
						...ImageGrid
					}
					... on DatoCmsMediaContent {
						...MediaContent
					}
					... on DatoCmsMediaContentGrid {
						...MediaContentGrid
					}
					... on DatoCmsCarousel {
						...ImageCarousel
					}
					... on DatoCmsClientCarousel {
						...ClientCarousel
					}
					... on DatoCmsPrincipleCallout {
						...PrincipleCallout
					}
					... on DatoCmsServicesBlock {
						...ServicesBlock
					}
					... on DatoCmsResult {
						...Results
					}
					... on DatoCmsPeopleCarousel {
						...PeopleCarousel
					}
					... on DatoCmsErgCarousel {
						...ErgCarousel
					}
					... on DatoCmsSubbrand {
						...SubbrandCallout
					}
					... on DatoCmsRecentInsight {
						...RecentInsight
					}
				}
				seo: seoMetaTags {
					...GatsbyDatoCmsSeoMetaTags
				}
			}
		}
		related: allDatoCmsProject(
			filter: { id: { ne: $id }, subbrand: { eq: $subbrand } }
		) {
			nodes {
				id
				title
				url
				client
				subbrand
				categories {
					id
					title
				}
				loader: image {
					alt
					url(imgixParams: { auto: "compress", w: "32" })
				}
				image {
					alt
					url(imgixParams: { auto: "compress", w: "1280" })
				}
			}
		}
	}
`;
